<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <artisio-modal size="md"
                   :visible="show"
                   :title="$t('Toggle Columns')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="modal.loading"
                   scrollable>
      <b-form-text class="mt-0 pb-2">
        {{ $t(`The maximum number of available columns are {total}`, {total: maxColumnNumber}) }}
      </b-form-text>
      <b-form-text class="mt-0 pb-2">
        {{ computedHint }}
      </b-form-text>
      <b-form-checkbox-group v-model="selectedColumns" stacked>
        <draggable :list="modal.data" handle=".handle">
          <div v-for="item in toggleColumnOptions" class="d-flex" :key="item.value">
            <font-awesome-icon v-if="selectedColumns.includes(item.value)" class="icon handle drag-icon" icon="bars"/>
            <b-form-checkbox class="pb-3" :style="checkboxStyle(item)" :value="item.value" :disabled="item.notEnabled">
              {{ item.text }}
            </b-form-checkbox>
          </div>
        </draggable>
      </b-form-checkbox-group>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
import ArtisioModal from "../artisio-modal/ArtisioModal";
import {createNamespacedHelpers} from "vuex";
import ProfileService from "../../../modules/auth/Profile/ProfileService";
import draggable from "vuedraggable";
import cloneDeep from "lodash/cloneDeep";

const {mapState, mapActions} = createNamespacedHelpers('global');
export default {
  name: "ToggleColumnModal",
  components: {ArtisioModal, draggable},
  props: {
    extraData: {
      type: Object,
      required: true,
    },
    uuid: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      showConfirmation: true,
      selectedColumns: [],
      maxColumnNumber: 20,
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      modal: state => state.toggleColumns.modal,
      show() {
        return this.uuid === this.modal.uuid && this.modal.show
      }
    }),
    toggleColumnOptions() {
      return this.modal.data.map(f => ({
        text: f.displayName || f.label,
        value: f.key,
        notEnabled: this.extraData.requiredFields.includes(f.key) ? true : this.filteredColumns.length === 20 && !this.selectedColumns.includes(f.key)
      }))
    },
    computedHint() {
      return this.$t(`Selected {selected} columns out of {total}`, {
        selected: this.filteredColumns.length,
        total: this.maxColumnNumber
      })
    },
    filteredColumns() {
      // todo remove exclude columns usage after all table exclude columns prop will be deleted
      return this.selectedColumns.filter(c => !this.extraData.requiredFields.includes(c) && (!this.extraData.excludeColumns || !this.extraData.excludeColumns.includes(c)))
    },
  },
  methods: {
    ...mapActions(['hideToggleColumnsModal', 'updateCurrentUser']),
    onShow() {
      this.selectedColumns = this.extraData.defaultFields
    },
    onHidden() {
      this.hideToggleColumnsModal()
    },
    async onSubmit() {
      let params = cloneDeep(this.currentUser);
      let selectedColumns = [];

      this.modal.data.forEach(d => {
        if (this.selectedColumns.includes(d.key)) {
          selectedColumns.push(d.key);
        }
      })

      if (params.visible_table_columns && Object.keys(params.visible_table_columns).length > 0) {
        const savedColumns = params.visible_table_columns;
        params.visible_table_columns = {
          ...savedColumns,
          [this.extraData.tableName]: {...savedColumns[this.extraData.tableName], 'toggle_columns': selectedColumns}
        };
      } else {
        params.visible_table_columns = {[this.extraData.tableName]: {'toggle_columns': selectedColumns}};
      }

      const {success, body} = await ProfileService.updateUserData(this.currentUser.uuid, {
        visible_table_columns: params.visible_table_columns,
        email: params.email
      });

      if (success) {
        this.$emit('on-column-save', {selectedColumns, isSaveAction: true});
        this.updateCurrentUser(body);
        this.$toast('success', this.$t(`Table columns were successfully updated`));
      } else {
        this.$toast('danger', this.$t(`Error occurred while updating table columns`));
      }
      this.hideToggleColumnsModal();
    },
    checkboxStyle(item) {
      return this.selectedColumns.includes(item.value) ? {paddingLeft: '2.5rem'} : {paddingLeft: '3.4rem'}
    },
  }
}
</script>

<style lang="scss" scoped>

.drag-icon {
  font-size: 1.2em;
  cursor: move;
  margin-top: 2px;
}

</style>
